import { AmbientLife } from './layers/AmbientLife';
import { BuildingsLayer } from './layers/BuildingsLayer';
import { CitizensLayer } from './layers/CitizensLayer';
import { LightingRig } from './layers/LightingRig';
import { RoadsLayer } from './layers/RoadsLayer';
import { SelectionOverlay } from './layers/SelectionOverlay';
import { TerrainGrid } from './layers/TerrainGrid';
import { VehiclesLayer } from './layers/VehiclesLayer';
import { WeatherEffects } from './layers/WeatherEffects';
import { CameraRig } from './rigs/CameraRig';

export function BeeHiveScene() {
  return (
    <>
      <CameraRig />
      <LightingRig />
      <TerrainGrid />
      <RoadsLayer />
      <SelectionOverlay />
      <BuildingsLayer />
      <CitizensLayer />
      <VehiclesLayer />
      <AmbientLife />
      <WeatherEffects />
    </>
  );
}
